"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_dom_1 = require("react-dom");
var d3_color_1 = require("d3-color");
var async_1 = require("../viewUtils/async");
var collections_1 = require("../viewUtils/collections");
var events_1 = require("../viewUtils/events");
var react_1 = require("../viewUtils/react");
var keyedObserver_1 = require("../viewUtils/keyedObserver");
var commands_1 = require("./commands");
var model_1 = require("./model");
var view_1 = require("./view");
var ElementLayer = /** @class */ (function (_super) {
    tslib_1.__extends(ElementLayer, _super);
    function ElementLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listener = new events_1.EventObserver();
        _this.batch = collections_1.createStringMap();
        _this.renderElements = new async_1.Debouncer();
        _this.updateSizes = new async_1.Debouncer();
        _this.onMount = function (layer) {
            _this.layer = layer;
        };
        _this.performRendering = function () {
            _this.forceUpdate();
        };
        _this.updateElementSize = function (element, node) {
            _this.batch[element.id] = { element: element, node: node };
            _this.updateSizes.call(_this.recomputeQueuedSizes);
        };
        _this.recomputeQueuedSizes = function () {
            var batch = _this.batch;
            _this.batch = collections_1.createStringMap();
            // hasOwnProperty() check is unneccessary here because of `createStringMap`
            // tslint:disable-next-line:forin
            for (var id in batch) {
                var _a = batch[id], element = _a.element, node = _a.node;
                var clientWidth = node.clientWidth, clientHeight = node.clientHeight;
                element.setSize({ width: clientWidth, height: clientHeight });
            }
        };
        return _this;
    }
    ElementLayer.prototype.render = function () {
        var _this = this;
        var _a = this.props, view = _a.view, group = _a.group, style = _a.style;
        var models = view.model.elements.filter(function (model) { return model.group === group; });
        return React.createElement("div", { className: 'ontodia-element-layer', ref: this.onMount, style: style }, models.map(function (model) { return React.createElement(OverlayedElement, { key: model.id, model: model, view: view, onResize: _this.updateElementSize, onRender: _this.updateElementSize }); }));
    };
    ElementLayer.prototype.componentDidMount = function () {
        var _this = this;
        var view = this.props.view;
        this.listener.listen(view.model.events, 'changeCells', function () {
            _this.renderElements.call(_this.performRendering);
        });
        this.listener.listen(view.events, 'syncUpdate', function (_a) {
            var layer = _a.layer;
            if (layer === view_1.RenderingLayer.Element) {
                _this.renderElements.runSynchronously();
            }
            else if (layer === view_1.RenderingLayer.ElementSize) {
                _this.updateSizes.runSynchronously();
            }
        });
    };
    ElementLayer.prototype.componentDidUpdate = function () {
        this.updateSizes.call(this.recomputeQueuedSizes);
    };
    ElementLayer.prototype.componentWillUnmount = function () {
        this.listener.stopListening();
        this.renderElements.dispose();
        this.updateSizes.dispose();
    };
    return ElementLayer;
}(React.Component));
exports.ElementLayer = ElementLayer;
exports.ElementContextTypes = {
    ontodiaElement: react_1.PropTypes.anything,
};
var OverlayedElement = /** @class */ (function (_super) {
    tslib_1.__extends(OverlayedElement, _super);
    function OverlayedElement(props) {
        var _this = _super.call(this, props) || this;
        _this.listener = new events_1.EventObserver();
        _this.disposed = false;
        _this.rerenderTemplate = function () {
            if (_this.disposed) {
                return;
            }
            _this.setState({ templateProps: _this.templateProps() });
        };
        _this.onMount = function (node) {
            if (!node) {
                return;
            }
            var _a = _this.props, onRender = _a.onRender, model = _a.model;
            onRender(model, node);
        };
        _this.onLoadOrErrorEvent = function () {
            var _a = _this.props, onResize = _a.onResize, model = _a.model;
            onResize(model, react_dom_1.findDOMNode(_this));
        };
        _this.onClick = function (e) {
            if (e.target instanceof HTMLElement && e.target.localName === 'a') {
                var anchor = e.target;
                var _a = _this.props, view = _a.view, model = _a.model;
                view.onIriClick(anchor.href, model, e);
            }
        };
        _this.onDoubleClick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            var _a = _this.props, view = _a.view, model = _a.model;
            view.model.history.execute(commands_1.setElementExpanded(model, !model.isExpanded));
        };
        _this.state = {
            templateProps: _this.templateProps(),
        };
        return _this;
    }
    OverlayedElement.prototype.getChildContext = function () {
        var ontodiaElement = {
            element: this.props.model,
        };
        return { ontodiaElement: ontodiaElement };
    };
    OverlayedElement.prototype.render = function () {
        var _a = this.props, model = _a.model, view = _a.view, onResize = _a.onResize, onRender = _a.onRender;
        if (model.temporary) {
            return React.createElement("div", null);
        }
        var template = view.getElementTemplate(model.data.types);
        var _b = model.position, _c = _b.x, x = _c === void 0 ? 0 : _c, _d = _b.y, y = _d === void 0 ? 0 : _d;
        var transform = "translate(" + x + "px," + y + "px)";
        // const angle = model.get('angle') || 0;
        // if (angle) { transform += `rotate(${angle}deg)`; }
        return React.createElement("div", { className: 'ontodia-overlayed-element', "data-element-id": model.id, style: { position: 'absolute', transform: transform }, tabIndex: 0, ref: this.onMount, 
            // resize element when child image loaded
            onLoad: this.onLoadOrErrorEvent, onError: this.onLoadOrErrorEvent, onClick: this.onClick, onDoubleClick: this.onDoubleClick }, React.createElement(template, this.state.templateProps));
    };
    OverlayedElement.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, model = _a.model, view = _a.view;
        this.listener.listen(view.events, 'changeLanguage', this.rerenderTemplate);
        this.listener.listen(model.events, 'changeData', this.rerenderTemplate);
        this.listener.listen(model.events, 'changeExpanded', this.rerenderTemplate);
        this.listener.listen(model.events, 'changePosition', function () { return _this.forceUpdate(); });
        this.listener.listen(model.events, 'requestedRedraw', function () { return _this.forceUpdate(); });
        this.listener.listen(model.events, 'requestedFocus', function () {
            var element = react_dom_1.findDOMNode(_this);
            if (element) {
                element.focus();
            }
        });
        this.typesObserver = keyedObserver_1.observeElementTypes(this.props.view.model, 'changeLabel', this.rerenderTemplate);
        this.propertiesObserver = keyedObserver_1.observeProperties(this.props.view.model, 'changeLabel', this.rerenderTemplate);
        this.observeTypes();
    };
    OverlayedElement.prototype.componentWillUnmount = function () {
        this.listener.stopListening();
        this.typesObserver.stopListening();
        this.propertiesObserver.stopListening();
        this.disposed = true;
    };
    OverlayedElement.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return nextState !== this.state;
    };
    OverlayedElement.prototype.componentDidUpdate = function () {
        this.observeTypes();
        this.props.onResize(this.props.model, react_dom_1.findDOMNode(this));
    };
    OverlayedElement.prototype.observeTypes = function () {
        var model = this.props.model;
        this.typesObserver.observe(model.data.types);
        this.propertiesObserver.observe(Object.keys(model.data.properties));
    };
    OverlayedElement.prototype.templateProps = function () {
        var _a = this.props, model = _a.model, view = _a.view;
        var types = model.data.types.length > 0
            ? view.getElementTypeString(model.data) : 'Thing';
        var label = model_1.formatLocalizedLabel(model.iri, model.data.label.values, view.getLanguage());
        var _b = this.styleFor(model), color = _b.color, icon = _b.icon;
        var propsAsList = this.getPropertyTable();
        return {
            elementId: model.id,
            data: model.data,
            iri: model.iri,
            types: types,
            label: label,
            color: color,
            iconUrl: icon,
            imgUrl: model.data.image,
            isExpanded: model.isExpanded,
            props: model.data.properties,
            propsAsList: propsAsList,
        };
    };
    OverlayedElement.prototype.getPropertyTable = function () {
        var _a = this.props, model = _a.model, view = _a.view;
        if (!model.data.properties) {
            return [];
        }
        var propertyIris = Object.keys(model.data.properties);
        var propTable = propertyIris.map(function (key) {
            var property = view.model.createProperty(key);
            var name = model_1.formatLocalizedLabel(key, property.label, view.getLanguage());
            return {
                id: key,
                name: name,
                property: model.data.properties[key],
            };
        });
        propTable.sort(function (a, b) {
            var aLabel = (a.name || a.id).toLowerCase();
            var bLabel = (b.name || b.id).toLowerCase();
            return aLabel.localeCompare(bLabel);
        });
        return propTable;
    };
    OverlayedElement.prototype.styleFor = function (model) {
        var _a = this.props.view.getTypeStyle(model.data.types), _b = _a.color, h = _b.h, c = _b.c, l = _b.l, icon = _a.icon;
        return {
            icon: icon,
            color: d3_color_1.hcl(h, c, l).toString(),
        };
    };
    OverlayedElement.childContextTypes = exports.ElementContextTypes;
    return OverlayedElement;
}(React.Component));
